import { Link, useNavigate } from 'react-router-dom';
import { supabase } from '../supabase';
import { useState, useEffect } from 'react';
import { FaHome, FaSquares, FaSignOutAlt, FaUser } from 'react-icons/fa';
import { CgCalendarNext, CgUser, CgHome, CgLogOut  } from 'react-icons/cg';
export default function Sidebar() {
  const navigate = useNavigate();

  const handleLogout = async () => {
    await supabase.auth.signOut();
    navigate('/login');
  };

  const menuItems = [
    { label: 'Home', path: '/dashboard', icon: CgHome },
    { label: 'Funis', path: '/dashboard/funnels', icon: CgCalendarNext }, 
    { label: 'Minha Conta', path: '/dashboard/account', icon: CgUser }, 
  ];



  const [user, setUser] = useState(null);

  useEffect(() => {
    const fetchUser = async () => {
      const { data: { user } } = await supabase.auth.getUser();
      setUser(user);
    } 
    fetchUser();
  }, []);

  return (
    <aside className="w-64 h-screen bg-gray-900 border-r border-gray-900 p-6 fixed top-0 left-0">
      <h2 className="text-2xl font-bold text-white mb-8 flex items-center gap-2"> 
        <img src="/images/logo_h.png" alt="Hotify" className="w-10 h-10" />
         <span className="text-white">Hotify</span>
         </h2>
      <nav className="flex flex-col space-y-4">
        {menuItems.map((item, index) => (
          <Link
            key={index}
            to={item.path}
            className="text-gray-200 hover:text-gray-400 transition flex items-center gap-2" 
          >
            <span className="text-gray-200 hover:text-gray-400 transition">
              <item.icon className="mr-2" />
            </span>
            <span className="text-gray-200 hover:text-gray-400 transition">
              {item.label}
            </span>
          </Link>
        ))}

          
        <button
          onClick={handleLogout}
          className="text-gray-500 text-left mt-8 hover:text-gray-400 flex items-center gap-2" 
        >

          
          <CgLogOut className="mr-2" />
          Sair
        </button>


{user?.email == 'g_stroligo@live.com' && (
            <Link to="/dashboard/admin" className="text-gray-200 hover:text-gray-400 transition">
              Admin
            </Link> 
          )}
      </nav>
    </aside>
  );
}
